import { ShareDialog } from "@/components/ShareDialog/ShareDialog";
import { PERMISSIONS } from "@/constants/permissions";
import { useHasPermission } from "@/hooks/usePermissions";
import { buildFileRecordDetailUrl } from "@/panes/file-record-detail";
import type { FileRecord, SubjectObjectType } from "@cohesive/api-client";

function fileRecordName(record: FileRecord): string {
  return record.path?.split("/").filter(Boolean).pop() || "File";
}

export function ShareFileRecordDialog({
  record,
  onClose,
}: {
  record: FileRecord;
  onClose: () => void;
}) {
  const isOrgAdmin = useHasPermission(PERMISSIONS.ORG_ADMIN.ALL);
  const name = fileRecordName(record);

  return (
    <ShareDialog
      resourceObjectType="file_record"
      resourceObjectId={record.id}
      subjectObjectType={[
        ...(isOrgAdmin ? (["organization"] as SubjectObjectType[]) : []),
        "organization_user" as SubjectObjectType,
        ...(isOrgAdmin ? (["group"] as SubjectObjectType[]) : []),
      ]}
      title={`Share "${name}"`}
      shareLinkUrl={buildFileRecordDetailUrl(record.id)}
      open
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
    />
  );
}
